import {
  HicapsConnectExtendedDataTypeGuard,
  IHicapsConnectMedicareClaimTransactionExtendedData,
  TransactionStatus,
} from '@principle-theorem/principle-core/interfaces';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GeneralProviderActionsService } from '../../../general-provider-actions.service';
import {
  ITransactionAction,
  ITransactionActionsData,
} from '../../../transaction-action';
import { TransactionHelpers } from '../../../transaction-helpers';

export class ApproveHicapsConnectMedicareTransaction
  implements
    ITransactionAction<IHicapsConnectMedicareClaimTransactionExtendedData>
{
  icon = 'done';
  label = 'Approve';
  inProgress$ = new BehaviorSubject<boolean>(false);
  typeGuardFn = HicapsConnectExtendedDataTypeGuard.isMedicareClaim;

  constructor(private _actions: GeneralProviderActionsService) {}

  canDo$(
    data: ITransactionActionsData<IHicapsConnectMedicareClaimTransactionExtendedData>
  ): Observable<boolean> {
    return TransactionHelpers.lastTransaction$(
      data,
      HicapsConnectExtendedDataTypeGuard.isMedicareClaim
    ).pipe(
      map((transaction) => {
        if (!transaction) {
          return false;
        }
        return transaction.status === TransactionStatus.Pending;
      })
    );
  }

  async do(
    data: ITransactionActionsData<IHicapsConnectMedicareClaimTransactionExtendedData>
  ): Promise<void> {
    this.inProgress$.next(true);
    await this._actions.approve(
      data.invoice,
      data.latestTransaction,
      'Approve Medicare Claim'
    );
    this.inProgress$.next(false);
  }
}
